module.exports = __webpack_public_path__ + "static/media/001-discount.e2f274f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/001-discount.svg
// module id = 1010
// module chunks = 0